// extracted by mini-css-extract-plugin
export default {"encouragement-msg":"encouragement-msg--iPtNh","encouragementMsg":"encouragement-msg--iPtNh","content":"content--LwB9V"};